/*
 * fn: toggleThemeCookie
 *
 * Sets the theme cookie
 *
 */
import { COOKIE_MAX_AGE } from '@/defs/cookie'

import { setCookie } from './setCookie'

export const toggleThemeCookie = () => {
  const { dataset } = document.documentElement
  const current = dataset.theme ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
  const theme = current === 'light' ? 'dark' : 'light'
  dataset.theme = theme
  setCookie('theme', theme, { maxAge: COOKIE_MAX_AGE })
}
